// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressBarVisible {
    height: 3px;
    width: 100px;
    top: 0;
    left: 0;
    position: absolute;
    background-color:var(--admin-color);
    opacity: 1;
}

.progressBarHide {
    opacity: 0;
    transition: opacity 3s;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ProgressBar/ProgressBar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B","sourcesContent":[".progressBarVisible {\n    height: 3px;\n    width: 100px;\n    top: 0;\n    left: 0;\n    position: absolute;\n    background-color:var(--admin-color);\n    opacity: 1;\n}\n\n.progressBarHide {\n    opacity: 0;\n    transition: opacity 3s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
